// extracted by mini-css-extract-plugin
export default {"list_wrapper":"PengalamanKerja_list_wrapper__5c-TR","item_wrapper":"PengalamanKerja_item_wrapper__cXeIw","date_wrapper":"PengalamanKerja_date_wrapper__tpN9o"};